import { useEffect, useState } from 'react';
import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import { isNative } from '../../config.js';
import Surveys from './Surveys.jsx';
import FieldSurveys, { FieldSurvey } from './Field.jsx';

// Which survey screens someone gets. The surveys page permission (Platform >
// Permissions) is all it takes: on a phone or in the app they get the on-site
// screens (nearest first, pick up, directions, GPS), whatever their NU group;
// on a computer the office gets the board. ?board=1 opens the board anyway
// (an office user on a phone importing a sheet).
const NARROW = '(max-width: 900px)';

function useNarrow() {
  const [narrow, setNarrow] = useState(() => typeof window !== 'undefined' && window.matchMedia?.(NARROW).matches);
  useEffect(() => {
    const m = window.matchMedia?.(NARROW);
    if (!m) return undefined;
    const on = () => setNarrow(m.matches);
    m.addEventListener('change', on);
    return () => m.removeEventListener('change', on);
  }, []);
  return narrow;
}

export function useOnSite(shell) {
  const [params] = useSearchParams();
  const narrow = useNarrow();
  if (shell === 'field') return true;
  if (params.get('board') === '1' || params.get('job') || params.get('tab')) return false;
  return isNative || narrow;
}

export function SurveysPage({ me, shell }) {
  return useOnSite(shell) ? <FieldSurveys me={me} shell={shell} /> : <Surveys me={me} />;
}

// /surveys/:id: the on-site screen, or the board with that job open.
export function SurveyPage({ me, shell }) {
  const { id } = useParams();
  if (useOnSite(shell)) return <FieldSurvey me={me} />;
  return <Navigate to={`/surveys?job=${id}`} replace />;
}
